<template>
  <div class="footer-explain-page">
    <div class="daishu-bottom-logo">
      <div class="tip" v-if="$route.name === 'report'" @click="toFeedback">
        报告有误？点击反馈 >
      </div>
      <div class="daishu-logo" v-if="!isWechatSubscription">
        本服务由{{ $brandConfig.companyName }}提供
      </div>
      <div class="daishu-tel">
        <i></i> <a :href="`tel:${daishuPhone}`">{{ daishuPhone }}</a>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.footer-explain-page {
  .daishu-bottom-logo {
    text-align: center;
    font-size: 24/200rem;
    color: #919191;
    .daishu-logo {
      padding-bottom: 7.5/200rem;
    }
    .tip {
      padding-bottom: 5/200rem;
      color: #118eea;
    }
    a {
      color: #999;
    }
  }
}
</style>

<script>
export default {
  name: "footerExplain",
  data() {
    return {
      isWechatSubscription,
      daishuPhone: brandConfig.daishuPhone,
    };
  },
  methods: {
    toFeedback() {
      this.$router.push("/feedback");
    },
  },
  mounted() {},
};
</script>
